export enum AnchorDrawer {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}
